export const EVENT_CATERING_FIELD_EVENT_TYPES = [
  'course',
  'education',
  'exercise',
  'activity',
] as const;

export type EventCateringFieldEventType =
  (typeof EVENT_CATERING_FIELD_EVENT_TYPES)[number];

export const EVENT_CATERING_FIELD_TYPE_LABELS: Record<
  EventCateringFieldEventType,
  string
> = {
  course: 'Kursus',
  education: 'Uddannelse',
  exercise: 'Øvelse',
  activity: 'Aktivitet',
};

export function cateringFieldEnabledOrgKey(eventType: string): string {
  return `events_catering_field_${eventType}_enabled`;
}

export function mapFormCateringToApi(
  value: unknown
): 'self_catering' | 'catering_included' | 'catering_not_included' {
  const v = String(value ?? '').trim();
  if (v === 'selv') {
    return 'self_catering';
  }
  if (v === 'lokation') {
    return 'catering_included';
  }
  return 'catering_not_included';
}

export function mapApiCateringToForm(value?: string | null): string {
  switch (value) {
    case 'self_catering':
      return 'selv';
    case 'catering_included':
      return 'lokation';
    default:
      return 'irrelevant';
  }
}

export const FORM_CATERING_CHOICE_VALUES = ['selv', 'lokation', 'irrelevant'] as const;

function isTruthySameCateringAsPrevious(value: unknown): boolean {
  return value === true || value === 'true';
}

/** Effective catering for additional_dates[rowIndex] after same-as-previous chain. */
export function effectiveCateringForAdditionalRow(
  data: Record<string, unknown>,
  rowIndex: number
): string {
  const main =
    String(data['catering'] || 'irrelevant').trim() || 'irrelevant';
  const additional = (data['additional_dates'] as Array<{
    same_catering_as_previous?: boolean | string;
    sub_event_catering?: string;
  }>) || [];
  if (rowIndex < 0) {
    return main;
  }
  let effective = main;
  for (let i = 0; i <= rowIndex && i < additional.length; i++) {
    const row = additional[i];
    if (!row) {
      continue;
    }
    if (isTruthySameCateringAsPrevious(row.same_catering_as_previous)) {
      continue;
    }
    const chosen = String(row.sub_event_catering || '').trim();
    if (chosen) {
      effective = chosen;
    }
  }
  return effective;
}

/** Catering on the day before a new additional_dates panel (for defaults). */
export function previousCateringBeforeAdditionalIndex(
  data: Record<string, unknown>,
  newPanelIndex: number
): string {
  if (newPanelIndex <= 0) {
    return (
      String(data['catering'] || 'irrelevant').trim() || 'irrelevant'
    );
  }
  return effectiveCateringForAdditionalRow(data, newPanelIndex - 1);
}
